@if (data$ | async; as component) {
  @if (component?.items) {
    <div class="title">{{ component.title }}</div>
    @if (items$ | async; as items) {
      <div class="link-items" [class.bordered]="component.linkStyle === 'BORDERED'">
        @for (item of items; track item) {
          <a [href]="item.url" title="{{ item.linkName }}">
            {{ item.linkName }}
          </a>
        }
      </div>
    }
  }
}
